import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from '../../services/analytics.service';

// The cookie banner for Google Analytics (production only — the app root draws it only when
// AnalyticsService is enabled). Accept and Reject side by side and alike; the page stays usable
// behind it. "Cookie settings" in the site's footers brings it back, to change the answer.
@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss'],
})
export class CookieConsentComponent implements OnInit {
  constructor(public readonly analytics: AnalyticsService) {}

  public ngOnInit(): void {
    this.analytics.start();
  }

  public accept(): void {
    this.analytics.setConsent('granted');
  }

  public reject(): void {
    this.analytics.setConsent('denied');
  }
}
